import CloseXS from '@semcore/ui/icon/Close/m';

interface Props {
    color?: string;
}

export function IconClose({ color }: Props) {
    return <CloseXS color={color} />;
}
